import {Payment} from "../../fo/booking/booking-confirm/payment";
import {Payement} from "./payment";


export class Organisation {
  //event
  public id:number;
  public name:  string;
  public 	adresse: string;
  public 	zipcode: string;
  public 	eventType: string = 'choose';
  public 	orgaType: string = 'choose';
  public city: string;
  public 	site: string;
  public country:string='selectionnez';
  public 	organization_statu: string = 'a';
  public payment_id:string;
  public orgafirstname:string;
  public orgalastaname:string;
  public phone:string;
  public email:string;
  public siret:string;
  public logo:string;
  //new
  public  website:string;
  public 	description: string;
  public 	instagram: string;
  public 	facebookPage: string;
  public 	twitterAccount: string;

  public payment:Payement = new Payement();



  constructor() {

  }

}
